// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore , collection, doc} from "firebase/firestore";



import 'firebase/firestore'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBWZ1jSo2iJMFjvxs2bWRRmq5L4n1cpbzk",
  authDomain: "beachtennismedellin-ed3eb.firebaseapp.com",
  projectId: "beachtennismedellin-ed3eb",
  storageBucket: "beachtennismedellin-ed3eb.appspot.com",
  messagingSenderId: "115821090734",
  appId: "1:115821090734:web:b95bc4c0dedc3750f0da3f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth=getAuth(app);
export const db2 = getFirestore();
